import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6df48561"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "about-me" }
const _hoisted_2 = {
  id: "about-wrapper",
  "data-scroll-speed": "0",
  "data-scroll": ""
}
const _hoisted_3 = {
  class: "description",
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#about-wrapper",
  "data-scroll-direction": "vertical"
}
const _hoisted_4 = ["data-scroll-speed", "data-scroll-direction"]

import { ref, onMounted, nextTick, onBeforeUnmount } from 'vue';
  import { hyphenate } from 'hyphen/de-1996';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AboutMe',
  props: {
    description: null,
    photoGrid: null
  },
  emits: ["rendered"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'rendered',): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    description: string;
    photoGrid: string[];
  };

  

  

  const hyphenatedDesc = ref('');
  hyphenate(props.description).then((result: string) => {
    hyphenatedDesc.value = result;
  })

  const picGridScrollDirection = ref('vertical');
  const checkWidth = () => {
    picGridScrollDirection.value = window.innerWidth > 800 ? 'vertical' : 'horizontal';
  }
  onMounted(() => {
    checkWidth()
    nextTick(() => {
      window.addEventListener('resize', checkWidth)

      // all elements loaded
      window.addEventListener('load', () => {
        emit('rendered');
      })
    })
  })
  onBeforeUnmount(() => window.removeEventListener('resize', checkWidth))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(hyphenatedDesc.value), 1)
      ]),
      _createElementVNode("section", {
        class: "photo-grid",
        "data-scroll": "",
        "data-scroll-speed": picGridScrollDirection.value === 'horizontal' ? 20 : 5,
        "data-scroll-direction": picGridScrollDirection.value
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.photoGrid, (img, picIndex) => {
          return (_openBlock(), _createElementBlock("span", {
            key: picIndex,
            style: _normalizeStyle(`background-image: url('${require('@/assets/media/images/' + img)}')`)
          }, null, 4))
        }), 128))
      ], 8, _hoisted_4)
    ])
  ]))
}
}

})